module.exports = __webpack_public_path__ + "img/match-stats-icon.21f70b61.svg";